import { useEffect, useState } from "react"

// Gli avvisi che spiegano un gesto, sotto la barra del telefono: "tieni
// premuta una freccia", "stringi le dita". Un gesto non si vede: si impara
// solo se qualcuno lo dice. Lo si dice per qualche apertura dell'app, e mai
// più dopo averlo usato una volta.
const MAX_SHOWINGS = 5

// le chiavi in uso, per non pescarne una sbagliata
export const HINTS = {
	weekJump: "incampo.weekJumpHint",
	pinch: "incampo.pinchHint",
	// nel profilo: tenere premuto il titolo di una scheda per riordinarle
	profileReorder: "incampo.profileReorderHint",
}

const read = key => {
	try {
		return JSON.parse(window.localStorage.getItem(key)) ?? { seen: 0, used: false }
	} catch {
		return { seen: 0, used: false }
	}
}

const write = (key, value) => {
	try {
		window.localStorage.setItem(key, JSON.stringify(value))
	} catch {
		// senza memoria l'avviso torna la prossima volta: pazienza
	}
}

// una volta per apertura dell'app, non a ogni passaggio sulle lezioni
const countedThisSession = new Set()

const useGestureHint = (key, isActive) => {
	const [state, setState] = useState(() => read(key))

	useEffect(() => {
		if (!isActive || countedThisSession.has(key)) return
		countedThisSession.add(key)
		const stored = read(key)
		if (stored.used) return
		const next = { ...stored, seen: stored.seen + 1 }
		write(key, next)
		setState(next)
	}, [key, isActive])

	const markUsed = () => {
		if (state.used) return
		const next = { ...state, used: true }
		write(key, next)
		setState(next)
	}

	return { showHint: isActive && !state.used && state.seen <= MAX_SHOWINGS, markUsed }
}

export default useGestureHint
